// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0b933e71] .van-nav-bar__left,[data-v-0b933e71] .van-nav-bar__title{color:#fff;font-family:Inter-Regular}[data-v-0b933e71] .van-nav-bar__left{font-weight:700;font-size:.45333rem;line-height:.53333rem}[data-v-0b933e71] .van-nav-bar__right{padding:0}[data-v-0b933e71] .van-nav-bar__right .lang-box{margin-right:.48rem}[data-v-0b933e71] .van-nav-bar__right .lang-box .status .status-active{background-color:transparent;color:#666}", ""]);
// Exports
module.exports = exports;
